module.exports = __webpack_public_path__ + "static/media/minus-button_icn.be77eec2.svg";